import { getDefaultHeight, SVG } from "./utils";

type Props = {
  color?: string;
} & React.SVGProps<SVGSVGElement>;

export const CopyIcon: React.FC<Props> = ({ color, ...svgProps }) => {
  return (
    <SVG
      viewBox="0 0 18.48 21.5"
      xmlns="http://www.w3.org/2000/svg"
      height={getDefaultHeight(svgProps, 21.5)}
      {...svgProps}
      fill={svgProps.fill ?? "none"}
      stroke={color ?? svgProps.stroke ?? "currentColor"}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M14.1 20.75H2.08a1.33 1.33 0 0 1-1.33-1.33V4.72" />
      <rect height="17" rx="2" width="14" x="3.73" y=".75" />
    </SVG>
  );
};
